module.exports = __webpack_public_path__ + "img/x-icon.f802e2db.svg";